import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Modal, Button } from 'antd';
import { Translate } from 'react-jhipster';
import { getSurveillant, deleteSurveillant } from './surveillant.reducer';
import { useAppDispatch, useAppSelector } from 'app/config/store';
export const SurveillantDeleteModal = (props: RouteComponentProps<{ id: string; ecoleid: string }>) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const dispatch = useAppDispatch();
  const surveillant = useAppSelector(state => state.surveillant.entity);
  const currentEcole = useAppSelector(state => state.ecole.entity);
  const showModal = () => {
    setIsModalVisible(true);
  };
  useEffect(() => {
    dispatch(getSurveillant(props.match.params.id));
  }, []);

  const handleClose = event => {
    event.stopPropagation();
    props.history.push(`/surveillant/${currentEcole && currentEcole.id}`);
  };

  const confirmDelete = event => {
    const entity = {
      ecoleId: props.match.params.ecoleid,
      id: props.match.params.id,
    };
    dispatch(deleteSurveillant(entity));
    handleClose(event);
  };

  const goBack = () => {
    props.history.goBack();
  };

  return (
    <Modal
      title="Confirmation de suppression"
      centered
      footer={[
        <Button key="back" onClick={goBack}>
          Annuler
        </Button>,
        <Button key="submit" style={{ backgroundColor: '#cd201f', color: 'white' }} onClick={confirmDelete}>
          Supprimer
        </Button>,
      ]}
      visible={true}
      closable={false}
    >
      Etes-vous certain de vouloir supprimer le surveillant {surveillant.firstName + surveillant.lastName} ?
    </Modal>
  );
};

export default SurveillantDeleteModal;
